import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { NationalProductsDetails } from '@/types/nationalProducts.types';
import { NationalProductsSelection } from '@/types/nationalProductsSelection.types';
import { useSTKContext } from '@/context/context';

export const useNationalProducts = (enabled: boolean) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<NationalProductsDetails[]>>({
    queryKey: ['nationalProducts'],
    queryFn: () => apiClient.get<NationalProductsDetails[]>('/products'),
    enabled,
  });
};

export const useUpdateNationalProductsIslock = () => {
  const { apiClient } = useSTKContext();
  return useMutation({
    mutationFn: (requestBody: NationalProductsSelection[]) => apiClient.put('/products/update', requestBody),
  });
};

export const identicalArrays = (originalData: NationalProductsDetails[], currentData: NationalProductsDetails[]) => {
  let identicalData = true;
  const stringToBoolean = (string: string | boolean) => (string === 'false' ? false : !!string);
  if (currentData === originalData) {
    identicalData = true;
  }
  if (currentData.length !== originalData.length) {
    return false;
  }
  for (let i = 0; i < currentData.length; i += 1) {
    const newLockBoolean = stringToBoolean(currentData[i].priceLock);
    const newMandatoryBoolean = stringToBoolean(currentData[i].mandatoryProductLock);
    if (newLockBoolean !== originalData[i].priceLock || newMandatoryBoolean !== originalData[i].mandatoryProductLock) {
      return false;
    }
  }
  return identicalData;
};
